import { FilterMatchMode } from "primereact/api";

export class RefComercial {

    model = {
        id: {
            value: null,
            export: true,
            header: 'Código',
            table: false,
            filterPlaceholder: 'Buscar por código',
            filterField: 'id',
            sort: true,
            matchMode: FilterMatchMode.EQUALS,
            showFilterMatchModes: false,
            headerStyle: { width: '10%', minWidth: '10rem' }
        },
        establecimiento: {
            value: '',
            export: true,
            header: 'ESTABLECIMIENTO',
            table: true,
            sort: false,
            headerStyle: { width: '30%', minWidth: '20rem' },
            filterPlaceholder: 'Buscar',
            filterField: 'establecimiento',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
        },
        direccion: {
            value: '',
            export: true,
            header: 'DIRECCIÓN',
            table: true,
            sort: false,
            headerStyle: { width: '30%', minWidth: '20rem' },
            filterPlaceholder: 'Buscar',
            filterField: 'direccion',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
        },
        telefono: {
            value: '',
            export: true,
            header: 'TELÉFONO',
            table: true,
            sort: false,
            filterPlaceholder: 'Buscar',
            filterField: 'telefono',
            matchMode: FilterMatchMode.CONTAINS,
            required: 'Campo requerido',
            maxLength: 'Máximo 40 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 40,
            min: 4,
        },
        compra_promedio: {
            value: 0,
            export: false,
            header: 'COMPRA PROMEDIO MENSUAL:',
            required: 'Valor requerido.'
        },
    }
}
